import { CommonModule } from '@angular/common';
import { FixDate } from './fixDate.pipe';
import { FixDateTime } from './fixDateTime.pipe';
import { NgModule } from '@angular/core';
import { Safe } from './safe.pipe';
import { FixDateUTC } from './fixDateUTC.pipe';
import { SmartNumber } from './smartNumber.pipe';

@NgModule({
  declarations: [FixDate, FixDateTime, Safe, FixDateUTC, SmartNumber],
  imports: [
    CommonModule
  ],
  providers: [Safe, FixDate, FixDateTime, FixDateUTC, SmartNumber],
  exports: [FixDate, FixDateTime, Safe, FixDateUTC, SmartNumber]
})
export class PipesModule { }
